import { mockBasketItemQuote } from '@domgen/dgx-fe-basket';
import { CheckoutCompletedQuote } from '../../models/checkout-completed-item/checkout-completed-quote.interface';
import { mockCheckoutCompletedQuoteConfirmation } from './checkout-completed-quote-confirmation.mock';

export const mockCheckoutCompletedQuote: CheckoutCompletedQuote = {
  item: mockBasketItemQuote,
  confirmation: mockCheckoutCompletedQuoteConfirmation,
};
